// extracted by mini-css-extract-plugin
export default {"toolsContent":"SolutionTools_toolsContent__lBynX","toolWrapper":"SolutionTools_toolWrapper__CqFcD","tool":"SolutionTools_tool__Tyu+J"};